import { z } from "zod";

import { isTextNamedColour, TextNamedColour } from "@holibob-packages/colour";

export const TextNamedColorSchema = z.custom<TextNamedColour>(isTextNamedColour, "Invalid text named colour");
